import { PolicyPodetailReq, PolicyPodetailResp } from 'app/bff/models/policy/policyPodetail';
import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { PaymentCreditAuthReq } from 'app/bff/models/payment/paymentCreditAuth';
import { ProcessStepCodesEnum } from 'app/features/Service/QueryPolicy/Pay/types';
import { PayState, PayActions, SERVICE_QUERY_POLICY_PAY__FETCH_POLICY_DETAIL, SERVICE_QUERY_POLICY_PAY__FETCH_POLICY_DETAIL_DONE, SERVICE_QUERY_POLICY_PAY__SET_ACCESSIBLE_STEP, SERVICE_QUERY_POLICY_PAY__SEND_OTP, SERVICE_QUERY_POLICY_PAY__SEND_OTP_DONE, SERVICE_QUERY_POLICY_PAY__RESEND_OTP, SERVICE_QUERY_POLICY_PAY__RESEND_OTP_DONE, SERVICE_QUERY_POLICY_PAY__AUTH_OTP, SERVICE_QUERY_POLICY_PAY__SET_POLICY_STATUS, SERVICE_QUERY_POLICY_PAY__EXECUTE_CREDIT_CARD_PAYMENT, SERVICE_QUERY_POLICY_PAY__UPDATE_CACHE, SERVICE_QUERY_POLICY_PAY__RESET_CACHE } from './types';

/**
 * @description 取得保單明細 (Action)
 * @param args 請求所需的參數
 */
export const fetchPolicyDetailAction = (args: PolicyPodetailReq): PayActions => ({
  type: SERVICE_QUERY_POLICY_PAY__FETCH_POLICY_DETAIL,
  payload: { args }
});

/**
 * @description 取得保單明細 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const fetchPolicyDetailDoneAction = (response: PolicyPodetailResp['policyTravel']): PayActions => ({
  type: SERVICE_QUERY_POLICY_PAY__FETCH_POLICY_DETAIL_DONE,
  payload: { response }
});

/**
 * @description 設置可訪問步驟 (Action)
 * @param step 當前步驟
 */
export const setAccessibleStepAction = (step: ProcessStepCodesEnum): PayActions => ({
  type: SERVICE_QUERY_POLICY_PAY__SET_ACCESSIBLE_STEP,
  payload: { step }
});

/**
 * @description 發送 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 */
export const sendOTPAction = (args: AaOtpSendcodeReq): PayActions => ({
  type: SERVICE_QUERY_POLICY_PAY__SEND_OTP,
  payload: { args }
});

/**
 * @description 發送 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const sendOTPDoneAction = (response: AaOtpSendcodeResp): PayActions => ({
  type: SERVICE_QUERY_POLICY_PAY__SEND_OTP_DONE,
  payload: { response }
});

/**
 * @description 重新發送 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 */
export const resendOTPAction = (args: AaOtpSendcodeReq): PayActions => ({
  type: SERVICE_QUERY_POLICY_PAY__RESEND_OTP,
  payload: { args }
});

/**
 * @description 重新發送 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const resendOTPDoneAction = (response: AaOtpSendcodeResp): PayActions => ({
  type: SERVICE_QUERY_POLICY_PAY__RESEND_OTP_DONE,
  payload: { response }
});

/**
 * @description 驗證 OTP 驗證碼 (Action)
 * @param args 驗證 OTP 請求所需的參數
 */
export const authOTPAction = (args: AaOtpVerifyReq): PayActions => ({
  type: SERVICE_QUERY_POLICY_PAY__AUTH_OTP,
  payload: { args }
});

/**
 * @description 設置保單狀態 (Action)
 * @param status 保單狀態
 */
export const setPolicyStatusAction = (status: PayState['policyStatus']): PayActions => ({
  type: SERVICE_QUERY_POLICY_PAY__SET_POLICY_STATUS,
  payload: { status }
});

/**
 * @description 執行信用卡繳費 (Action)
 * @param args 請求所需的參數
 */
export const executeCreditCardPaymentAction = (args: PaymentCreditAuthReq): PayActions => ({
  type: SERVICE_QUERY_POLICY_PAY__EXECUTE_CREDIT_CARD_PAYMENT,
  payload: { args }
});

/**
 * @description 更新資料緩存 (Action)
 * @param cache 緩存資料
 */
export const updateCacheAction = (cache: PayState): PayActions => ({
  type: SERVICE_QUERY_POLICY_PAY__UPDATE_CACHE,
  payload: { cache }
});

/**
 * @description 重置資料緩存 (Action)
 */
export const resetCacheAction = (): PayActions => ({
  type: SERVICE_QUERY_POLICY_PAY__RESET_CACHE
});
